import { Action } from 'edocatbase/Global';
import constants from '../constants';
import { default as form_constants } from '../Components/Form/constants';
import { assocPath } from "ramda";

const initialState: { [key: string]: any } = {
  usedObjects: {
    //can be empty or predefined values
  }
}

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case form_constants.FETCH_ITEMS_BY_NODES_SUCCESS: {
      const { response: { data: { items: data } } } = action.payload;
      if (Array.isArray(data)) {
        return assocPath(['usedObjects'], { ...state.usedObjects, ...{ ...Object.fromEntries(data.map((it: any) => [it.nodeRef, it])) } }, state);
      }
      return state;
    }
    case form_constants.ON_FORM_CHANGE: {
      const { path, value } = action.payload;

      if (typeof value?.value === 'string' && value.value.startsWith("workspace://")) {
        var newVal = { ...value, title: value?.label }
        return assocPath(['usedObjects', value.value], newVal, state);
      } else if (Array.isArray(value)) {
        var toCache = Object.fromEntries(value.filter((item: any) => item?.value?.startsWith("workspace://")).map((item: any) => ([item.value, item])));
        return assocPath(['usedObjects'], { ...state.usedObjects, ...toCache }, state);
      }
      return state;
    }
    case constants.PROMISE_UPDATE_CACHE_SUCCESS: {
      return assocPath(['usedObjects'], { ...state.usedObjects, ...action.payload }, state);
    }
    default: {
      return state;
    }
  }
};

export default reducer;
